import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ConsultationPage: React.FC = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen" dir="ltr">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-[1300] overflow-visible h-[72px]">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-[72px]">
            <Link className="flex items-center" to="/">
              <img 
                alt="VIPA Trading Company" 
                className="h-16 w-auto" 
                src="https://static.readdy.ai/image/b722d8dcf1c144135667d61789b02d4e/99b5c3dffef714fa12a155204a44cba1.png"
              />
            </Link>
            
            <nav className="hidden lg:flex items-center space-x-8">
              <Link className="text-[#595A5C] hover:text-[#E71B25] transition-colors font-medium" to="/">
                Home
              </Link>
              <div className="relative">
                <button 
                  className="text-[#E71B25] hover:text-[#d11620] transition-colors font-medium flex items-center cursor-pointer whitespace-nowrap focus:outline-none focus:text-[#E71B25]"
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                  Services
                  <i className={`ri-arrow-down-s-line ml-1 transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : ''}`}></i>
                </button>
                {isDropdownOpen && (
                  <div className="absolute top-full left-0 mt-0 min-w-[260px] bg-white rounded-lg shadow-lg border border-[#C3AAAB33] z-[1000]">
                    <div className="py-2">
                      <Link to="/services/construction" className="block px-4 py-3 text-[#595A5C] hover:bg-[#F7F7F7] hover:text-[#E71B25] transition-colors text-left">
                        Construction & Roads
                      </Link>
                      <Link to="/services/oil" className="block px-4 py-3 text-[#595A5C] hover:bg-[#F7F7F7] hover:text-[#E71B25] transition-colors text-left">
                        Oil & Gas
                      </Link>
                      <Link to="/services/gold" className="block px-4 py-3 text-[#595A5C] hover:bg-[#F7F7F7] hover:text-[#E71B25] transition-colors text-left">
                        Gold Trading
                      </Link>
                      <Link to="/services/defense" className="block px-4 py-3 text-[#595A5C] hover:bg-[#F7F7F7] hover:text-[#E71B25] transition-colors text-left">
                        Defense Systems
                      </Link>
                      <Link to="/consultation" className="block px-4 py-3 text-[#E71B25] bg-[#F7F7F7] hover:text-[#d11620] transition-colors text-left font-medium">
                        Consulting
                      </Link>
                    </div>
                  </div>
                )}
              </div>
              <Link className="text-[#595A5C] hover:text-[#E71B25] transition-colors font-medium" to="/about">
                About Us
              </Link>
              <Link className="text-[#595A5C] hover:text-[#E71B25] transition-colors font-medium" to="/contact">
                Contact
              </Link>
            </nav>

            <div className="hidden lg:flex items-center space-x-4">
              <a data-lang="ar" className="text-[#595A5C] hover:text-[#E71B25] transition-colors font-medium cursor-pointer">
                العربية
              </a>
              <Link to="/contact">
                <button 
                  type="button" 
                  className="inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap border-2 border-[#E71B25] text-[#E71B25] hover:bg-[#E71B25] hover:text-white px-4 py-2 text-sm"
                >
                  Contact Us
                </button>
              </Link>
            </div>

            <button 
              className="lg:hidden text-[#595A5C] cursor-pointer" 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <i className="ri-menu-line text-2xl"></i>
            </button>
          </div>
        </div>
      </header>

      {/* Breadcrumb */}
      <div className="bg-gray-50 py-4">
        <div className="container mx-auto px-4">
          <div className="flex items-center space-x-2 text-sm text-gray-600">
            <Link to="/" className="hover:text-red-600 cursor-pointer">Home</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/services" className="hover:text-red-600 cursor-pointer">Services</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-red-600">Consulting</span>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                Specialized Consultations
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed">
                We provide specialized consultations in feasibility, risk, contracts, and expansion strategies—plus technical, industrial, and logistics consulting for civil and defense sectors, anchored in quality, transparency, safety, and innovation.
              </p>
            </div>
            <div className="lg:order-last">
              <img 
                src="https://static.readdy.ai/image/b722d8dcf1c144135667d61789b02d4e/7faf1e0fdfa17e3763bee5f903dbd5c4.jfif"
                alt="Professional consultation meeting"
                className="w-full h-96 object-cover object-top rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services Scope */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">Our Services Scope</h2>
          </div>
          
          <div className="max-w-4xl mx-auto">
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <p className="text-lg text-gray-700">Investment & financial feasibility studies</p>
              </div>
              
              <div className="flex items-start">
                <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <p className="text-lg text-gray-700">Comprehensive project studies and opportunity evaluation</p>
              </div>
              
              <div className="flex items-start">
                <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <p className="text-lg text-gray-700">Risk management & mitigation studies</p>
              </div>
              
              <div className="flex items-start">
                <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <p className="text-lg text-gray-700">Risk registers and contract risk control</p>
              </div>
              
              <div className="flex items-start">
                <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <p className="text-lg text-gray-700">Industrial expansion strategy</p>
              </div>
              
              <div className="flex items-start">
                <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <p className="text-lg text-gray-700">Technical consulting for industrial/logistics sectors</p>
              </div>
              
              <div className="flex items-start">
                <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <p className="text-lg text-gray-700">Supply-chain optimization and process improvement</p>
              </div>

              <div className="flex items-start">
                <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <p className="text-lg text-gray-700">Specialized advisory for local markets/authorities</p>
              </div>

              <div className="flex items-start">
                <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <p className="text-lg text-gray-700">Tailored investment solutions</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Methodology */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">Our Methodology</h2>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-white text-2xl font-bold">1</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Analysis & Assessment</h3>
              <p className="text-gray-600">
                Diagnose needs and assess current situation comprehensively
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-white text-2xl font-bold">2</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Strategic Planning</h3>
              <p className="text-gray-600">
                Develop comprehensive strategy and detailed action plan
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-white text-2xl font-bold">3</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Execution & Follow-up</h3>
              <p className="text-gray-600">
                Supervise delivery and ensure implementation progress
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-white text-2xl font-bold">4</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Evaluation & Improvement</h3>
              <p className="text-gray-600">
                Measure results and enhance performance continuously
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Vipa */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">Why Choose VIPA for Trading?</h2>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow">
              <div className="w-12 h-12 bg-red-600 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-award-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Deep Expertise</h3>
              <p className="text-gray-600">
                Senior experts with extensive experience across wide range of sectors
              </p>
            </div>
            
            <div className="bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow">
              <div className="w-12 h-12 bg-red-600 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-settings-3-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Tailored Solutions</h3>
              <p className="text-gray-600">
                Customized solutions specifically designed for each client's unique needs
              </p>
            </div>
            
            <div className="bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow">
              <div className="w-12 h-12 bg-red-600 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-line-chart-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Measurable Results</h3>
              <p className="text-gray-600">
                Clear KPIs and performance tracking to ensure tangible outcomes
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-red-600">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
            Need a Specialized Consultation?
          </h2>
          <p className="text-xl text-red-100 mb-10 max-w-3xl mx-auto">
            Contact us today for a free consultation and to discuss your needs.
          </p>
          <Link to="/contact">
            <button 
              type="button" 
              className="inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap bg-white text-[#E71B25] hover:bg-gray-100 shadow-sm hover:shadow-md px-8 py-4 text-lg"
            >
              Request Quote
            </button>
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-16">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-6">
                <img 
                  alt="VIPA Trading Company" 
                  className="h-20 w-auto mr-4" 
                  src="https://static.readdy.ai/image/b722d8dcf1c144135667d61789b02d4e/99b5c3dffef714fa12a155204a44cba1.png"
                />
                <div>
                  <h2 className="text-2xl font-bold text-white mb-1">VIPA Trading Company</h2>
                  <p className="text-red-600 text-sm font-medium">شركة فيبا التجارية</p>
                </div>
              </div>
              <p className="text-gray-400 mb-6">
                A leading Kuwaiti multi-activity company, providing integrated solutions in construction & roads, petroleum, gold, defense, and consulting with the highest international quality standards.
              </p>
              <div className="flex space-x-4">
                <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-twitter-fill text-xl"></i>
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-linkedin-fill text-xl"></i>
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-instagram-fill text-xl"></i>
                </a>
              </div>
            </div>
            
            <div>
              <h3 className="text-lg font-semibold mb-6">Quick Links</h3>
              <ul className="space-y-3">
                <li><Link to="/" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Home</Link></li>
                <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors cursor-pointer">About Us</Link></li>
                <li><Link to="/services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Services</Link></li>
                <li><Link to="/contact" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Contact</Link></li>
                <li><Link to="/consultation" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Consulting</Link></li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-lg font-semibold mb-6">Services</h3>
              <ul className="space-y-3">
                <li><Link to="/services/construction" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Construction & Roads</Link></li>
                <li><Link to="/services/oil" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Oil & Gas</Link></li>
                <li><Link to="/services/gold" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Gold Trading</Link></li>
                <li><Link to="/services/defense" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Defense Systems</Link></li>
                <li><Link to="/consultation" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Consulting</Link></li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-lg font-semibold mb-6">Contact Info</h3>
              <div className="space-y-3">
                <div className="flex items-center">
                  <i className="ri-mail-line text-red-600 mr-3"></i>
                  <span className="text-gray-400">info@vipatradingco.com</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-phone-line text-red-600 mr-3"></i>
                  <span className="text-gray-400">+965 123 456 789</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-map-pin-line text-red-600 mr-3 mt-1"></i>
                  <span className="text-gray-400">Kuwait City<br />State of Kuwait</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-12 pt-8 text-center">
            <p className="text-gray-400">
              © 2024 VIPA Trading Company. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ConsultationPage;